const DEFAULT_AVATAR = require('@/static/img/default-avatar.png');
// 直接导出上一行的话，ts文件中import时报错，因此专门写一行导出
export const DEFAULTAVATAR = DEFAULT_AVATAR;
const extuinInfoObj = {};
const defaultInfo = {
  name: '',
  avatar: DEFAULT_AVATAR,
};

// 用例获取并缓存B侧工号信息
export function extuinInfo(extuin, saveInfo) {
  if (saveInfo) { // 保存
    extuinInfoObj[extuin] = saveInfo;
  } else {
    const uInfo = extuinInfoObj[extuin];
    if (uInfo) {
      return uInfo;
    }
    return null;
  }
}

// 获取默认信息
export function defaultExtuinInfo(extuin) {
  if (extuin) {
    Object.assign(defaultInfo, extuin);
  } else {
    return defaultInfo;
  }
}

/**
 * 获取缓存的信息或者从ws拉取
 * @param {String|Number} extuin 工号
 * @param {Function} fetchFunc ws获取userInfo的接口
 * @returns userInfo
 */
export async function getOrFetchExtuinInfo(extuin, fetchFunc) {
  if (extuin) {
    let uInfo = null;
    uInfo = extuinInfo(extuin);
    if (uInfo) {
      return uInfo;
    }

    uInfo = await fetchFunc(extuin);
    if (uInfo) {
      if (!uInfo.avatar) {
        uInfo.avatar = DEFAULT_AVATAR; // 没有头像时，使用默认头像兜底。
      }
      extuinInfo(extuin, uInfo);
      return uInfo;
    }
  }
  return defaultExtuinInfo();
}
